const ApiDocIcon = () => {
    return (
        <svg width={16} height={17} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_24_14897" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x={0} y={0} width={16} height={17}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="black"
                    d="M9.333 4.417c0 .11-.035.216-.097.294A.304.304 0 019 4.833a.304.304 0 01-.236-.122.475.475 0 01-.097-.294c0-.11.035-.217.097-.295A.304.304 0 019 4c.088 0 .173.044.236.122a.475.475 0 01.097.295zm0 1.25v2.5H10V9H8.667V6.5H8v-.833h1.333z"
                ></path>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="black"
                    d="M13.866 14.204a1.253 1.253 0 01-.146-.23 1.883 1.883 0 01-.181-.84c0-.387.095-.666.181-.842.04-.081.09-.158.146-.23l.003-.004a.47.47 0 00.131-.325V1.467a.47.47 0 00-.135-.33.459.459 0 00-.326-.137H4.272l-.077.005c-.354.025-.7.12-1.017.278a2.09 2.09 0 00-.812.712c-.23.349-.366.79-.366 1.338v9.8c0 .433.108.787.294 1.069.184.278.426.458.653.574.27.135.566.211.868.224h.031v-.933c-.004 0-.014 0-.027-.002a1.231 1.231 0 01-.46-.124.757.757 0 01-.297-.257c-.074-.112-.139-.283-.139-.55 0-.268.065-.44.139-.551.075-.111.178-.2.299-.257a1.23 1.23 0 01.485-.126h8.915a2.945 2.945 0 00-.146.933c0 .369.062.682.146.934h-4.3V15h5.078a.458.458 0 00.425-.285.472.472 0 00-.094-.506l-.004-.005zM3.591 2.117c.085-.043.172-.076.255-.102v9.252h-.031a2.146 2.146 0 00-.868.224l-.024.013v-8.17c0-.386.094-.644.211-.821.119-.18.281-.306.457-.396zm1.178 9.15V1.933h7.308a1 1 0 011 1v8.334H4.769z"
                ></path>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="black"
                    d="M8 13H5v2.5a.5.5 0 00.854.353l.646-.647.646.647A.5.5 0 008 15.5V13z"
                ></path>
            </mask>
            <g mask="url(#mask0_24_14897)">
                <rect y="0.5" width={16} height={16} fill="#A0AEC0" />
            </g>
        </svg>
    );
};
export default ApiDocIcon;
